import classNames from 'classnames'

import Text from '../../../../Text'
import {
  getCalendarGridPopoverSecondaryLabel,
  getCalendarGridPopoverTitle,
} from '../../../CalendarGrid.utils'

import { QA_NAME_CALENDAR_GRID_DAY_POPOVER_ROW_SECONDARY_LABEL } from './CalendarGridDayPopoverRowLabels.constants'
import { getIsCalendarGridSecondaryLabelShown } from './CalendarGridDayPopoverRowLabels.utils'

import * as styles from './CalendarGridDayPopoverRowLabels.module.css'

function CalendarGridDayPopoverRowLabels({
  isSecondaryLabelClickable,
  item,
  onClickSecondaryLabel,
}) {
  const secondaryLabel = getCalendarGridPopoverSecondaryLabel(item)

  return (
    <div className={styles.CalendarGridDayPopoverRowLabels}>
      <Text className={styles.label}>{getCalendarGridPopoverTitle(item)}</Text>
      {getIsCalendarGridSecondaryLabelShown({
        isSecondaryLabelClickable,
        secondaryLabel,
      }) ? (
        <Text
          isSecondary
          className={classNames(styles.details, {
            [styles.clickable]: isSecondaryLabelClickable,
          })}
          qaName={QA_NAME_CALENDAR_GRID_DAY_POPOVER_ROW_SECONDARY_LABEL}
          onClick={onClickSecondaryLabel}
        >
          {secondaryLabel}
        </Text>
      ) : null}
    </div>
  )
}

export default CalendarGridDayPopoverRowLabels
